import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: {
  contentGenerationInProgress: boolean;
  contentGenerationError: string | null;
} = {
  contentGenerationInProgress: false,
  contentGenerationError: null,
};

const contentGenerationSlice = createSlice({
  name: 'contentGeneration',
  initialState,
  reducers: {
    contentGenerationStarted: (state) => {
      state.contentGenerationInProgress = true;
    },
    contentGenerationFinished: (
      state,
      action?: PayloadAction<string | undefined>
    ) => {
      state.contentGenerationInProgress = false;
      state.contentGenerationError = action?.payload || null;
    },
  },
});

const selectContentGenerationStatus = (state) => {
  const { contentGenerationInProgress, contentGenerationError } =
    state[contentGenerationSlice.name];

  return {
    contentGenerationInProgress,
    contentGenerationError,
  };
};

const { contentGenerationStarted, contentGenerationFinished } =
  contentGenerationSlice.actions;

export {
  contentGenerationSlice,
  contentGenerationStarted,
  contentGenerationFinished,
  selectContentGenerationStatus,
};
